import { PropsWithChildren, AnchorHTMLAttributes } from 'react';
import { Link } from './index';
import { cn } from '@/shared/utils/cn';

type NavLinkProps = {
  href: string;
  escapeAppRouter?: boolean;
} & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'popover'>;

export const CtaLink = ({
  href,
  children,
  className,
  escapeAppRouter = false,
  ...props
}: PropsWithChildren<NavLinkProps>) => {
  if (escapeAppRouter) {
    return (
      <a
        href={href}
        className={cn(
          'bg-primary font-sans-bold text-text hover:bg-primary-hover hover:text-text inline-flex items-center justify-center rounded-[3px] px-4 py-2 text-center transition-colors disabled:opacity-30',
          className,
        )}
        {...props}
      >
        {children}
      </a>
    );
  }
  return (
    <Link
      href={href}
      prefetch={false}
      className={cn(
        'bg-primary font-sans-bold text-text hover:bg-primary-hover hover:text-text inline-flex items-center justify-center rounded-[3px] px-4 py-2 text-center transition-colors disabled:opacity-30',
        className,
      )}
      {...props}
    >
      {children}
    </Link>
  );
};
